import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Popover } from 'react-bootstrap'

import './style.css'

class CustomTooltip extends React.Component {
  render () {
    return <OverlayTrigger trigger={['hover', 'focus']} placement={this.props.tooltipPosition} overlay={popover(this.props.toolTipTitle, this.props.toolTipText)}>
      {this.props.children}
    </OverlayTrigger>
  }
}

function popover (title, text) {
  return <Popover id='popover-trigger-hover-focus' title={title}>
    {text}
  </Popover>
}

CustomTooltip.defaultProps = {
  tooltipPosition: 'top'
}

CustomTooltip.propTypes = {
  tooltipPosition: PropTypes.string.isRequired,
  toolTipText: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  toolTipTitle: PropTypes.string,
  children: PropTypes.object.isRequired
}

export { CustomTooltip }



// WEBPACK FOOTER //
// ./src/components/common/CustomTooltip/CustomTooltip.js